import type { Gender } from '~constants/gender';
import type { Desire } from '~features/gridFilters';

import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

export const useGridCardClick = ({
	index,
	bot_UserId,
	isAuthorizedZone,
}: {
	index: number;
	bot_UserId: number;
	isAuthorizedZone: boolean;
}) =>
	useSendEvent(
		events.grid.cardClick,
		{
			index,
			bot_UserId,
			zone: isAuthorizedZone ? 'auth' : 'non-auth',
		},
		{
			forceSendDemoUser: true,
		}
	);

export const useGridViewed = () => useSendEvent(events.grid.viewGrid);

export const useGridFilterApplied = ({
	text,
	safeMode,
	isAuthorizedZone,
	manualFilters,
	desires,
	ageMin,
	ageMax,
	gender,
	botGrid,
	createdBy,
}: {
	text?: string;
	safeMode: boolean;
	isAuthorizedZone: boolean;
	manualFilters: boolean;
	desires?: Desire;
	ageMin: string;
	ageMax: string;
	gender?: Gender;
	createdBy?: string;
	botGrid: string[];
}) =>
	useSendEvent(
		events.grid.filterApplied,
		{
			text_filtered: text ?? 'NULL',
			filters_manual: +manualFilters,
			desires,
			age: `${ageMin}-${ageMax}`,
			safe: safeMode ? 'SFW' : 'NSFW',
			zone: isAuthorizedZone ? 'auth' : 'non-auth',
			createdBy,
			gender,
			sorting_bot_grid:
				botGrid.length === 0
					? 'NULL'
					: botGrid.map((botId, index) => {
							return { [index]: botId };
					  }),
		},
		{
			forceSendDemoUser: true,
		}
	);
